import 'bulma/css/bulma.min.css';
import React, { Fragment, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconLookup, IconDefinition, findIconDefinition, IconPrefix, IconName } from '@fortawesome/fontawesome-svg-core'
import NotificationSetting from '../dataObjects/NotificationSetting';

const PriorityType = {
    High: 2,
    Normal: 1,
    Off: 0
}

interface Props {
    displayAlertModal: any;
}


function NotificationSettingComponent(props: Props) {

    const settingStyle = {
      
        settingNameStyle: {
            display: "block"
        },

        iconDiplay: {
            marginRight: "10px"
        },

        cellStyle: {
            verticalAlign: "middle"
        }


    };

    let settings: NotificationSetting[] = new Array();
    const [isSettingActive, setSettingCss] = useState('');
    const [notificationsSettings, setSettings] = useState(settings);

    const fetchSettings = async () => {
        fetch(`/Notifications/GetSettings`)
            .then(res => res.json())
            .then(res => {
                if (res.isError) {
                    displayAlertModal("is-danger", "Error", res.errorMessage, res.secondaryErrorMessage);
                }
                else {
                    setSettings(res.result)
                }
            });
    };

    function getApplicationIconType(iconString: string) {
        let iconGroup = iconString.substr(0, 3);
        let iconType = iconString.substr(7);
        const iconLookup: IconLookup = { prefix: iconGroup as IconPrefix, iconName: iconType as IconName }
        const applicationIconDefinition: IconDefinition = findIconDefinition(iconLookup)
        return applicationIconDefinition;
    }

    function toggleSettingComponent() {
        if (isSettingActive == '') {
            fetchSettings();
            setSettingCss('is-active');
        }
        else {
            setSettingCss('');
        }
    }

    function displaySettingHtml(item:any, index: number) {
        let currentNotificationSetting = notificationsSettings[index];
        let previousNotificationSetting = currentNotificationSetting;
        if (index>0) {
            previousNotificationSetting = notificationsSettings[index - 1];
        }

        if (currentNotificationSetting.applicationName != previousNotificationSetting.applicationName || index==0) {
            return (
                <Fragment key={item.notificationTypeId}>
                    <tr>
                        <td colSpan={3} className="has-text-link has-text-weight-bold has-background-light">
                            <span style={settingStyle.iconDiplay}><FontAwesomeIcon title="High Priority" icon={getApplicationIconType(currentNotificationSetting.applicationIconClass)} /></span>
                        {currentNotificationSetting.applicationName}
                        </td>
                    </tr>
                    <tr>
                        <td className="has-text-weight-medium" style={settingStyle.cellStyle}>
                            {currentNotificationSetting.notificationTypeDescription}
                        </td>
                        <td className="has-text-centered" style={settingStyle.cellStyle}>
                            <div className="field has-addons">
                                <p className="control">
                                    <button className={`button is-small ${getDefaultPriorityCss(currentNotificationSetting.priorityTypeId, PriorityType.High)}`} onClick={() => updateSetting(currentNotificationSetting.notificationTypeId, PriorityType.High, currentNotificationSetting.isToasterEnabled)} >
                                        <span>High Priority</span>
                                    </button>
                                </p>
                                <p className="control">
                                    <button className={`button is-small ${getDefaultPriorityCss(currentNotificationSetting.priorityTypeId, PriorityType.Normal)}`} onClick={() => updateSetting(currentNotificationSetting.notificationTypeId, PriorityType.Normal, currentNotificationSetting.isToasterEnabled)}>
                                        <span>Normal</span>
                                    </button>
                                </p>
                                <p className={`control ${currentNotificationSetting.allowNotificationsOff? "" : "is-hidden"}`}>
                                    <button className={`button is-small ${getDefaultPriorityCss(currentNotificationSetting.priorityTypeId, PriorityType.Off)}`} onClick={() => updateSetting(currentNotificationSetting.notificationTypeId, PriorityType.Off, currentNotificationSetting.isToasterEnabled)}>
                                        <span>Off</span>
                                    </button>
                                </p>
                            </div>
                        </td>
                        <td className="has-text-centered" style={settingStyle.cellStyle}>
                            <div className="field has-addons">
                                <p className="control">
                                    <button className="button is-small">
                                        <span className="icon">
                                            <input type="checkbox" checked={currentNotificationSetting.isToasterEnabled} onChange={() => updateSetting(currentNotificationSetting.notificationTypeId, currentNotificationSetting.priorityTypeId, currentNotificationSetting.isToasterEnabled, true)} />
                                        </span>
                                        <span>Toast On?</span>
                                    </button>
                                </p>
                            </div>
                        </td>
                    </tr>
                </Fragment>
            )
        }
        else {
            return (
                <tr key={item.notificationTypeId}>
                    <td className="has-text-weight-medium" style={settingStyle.cellStyle}>{currentNotificationSetting.notificationTypeDescription}</td>
                    <td className="has-text-centered" style={settingStyle.cellStyle}>
                        <div className="field has-addons">
                            <p className="control">
                                <button className={`button is-small ${getDefaultPriorityCss(currentNotificationSetting.priorityTypeId, PriorityType.High)}`} onClick={() => updateSetting(currentNotificationSetting.notificationTypeId, PriorityType.High, currentNotificationSetting.isToasterEnabled)}>
                                    <span>High Priority</span>
                                </button>
                            </p>
                            <p className="control">
                                <button className={`button is-small ${getDefaultPriorityCss(currentNotificationSetting.priorityTypeId, PriorityType.Normal)}`} onClick={() => updateSetting(currentNotificationSetting.notificationTypeId, PriorityType.Normal, currentNotificationSetting.isToasterEnabled)}>
                                    <span>Normal</span>
                                </button>
                            </p>
                            <p className={`control ${currentNotificationSetting.allowNotificationsOff ? "" : "is-hidden"}`}>
                                <button className={`button is-small ${getDefaultPriorityCss(currentNotificationSetting.priorityTypeId, PriorityType.Off)}`} onClick={() => updateSetting(currentNotificationSetting.notificationTypeId, PriorityType.Off, currentNotificationSetting.isToasterEnabled)}>
                                    <span>Off</span>
                                </button>
                            </p>
                        </div>
                    </td>
                    <td className="has-text-centered" style={settingStyle.cellStyle}>
                        <div className="field has-addons">
                            <p className="control">
                                <button className="button is-small">
                                    <span className="icon">
                                        <input type="checkbox" checked={currentNotificationSetting.isToasterEnabled} onChange={() => updateSetting(currentNotificationSetting.notificationTypeId, currentNotificationSetting.priorityTypeId, currentNotificationSetting.isToasterEnabled, true)} />
                                    </span>
                                    <span>Toast On?</span>
                                </button>
                            </p>
                        </div>
                    </td>
                </tr>
            )
        }
        
    }

    function getDefaultPriorityCss(defaultType: number, buttonType: number) {
        if (defaultType == buttonType) {
            return "is-info"
        }
        return "";
    }

    function updateSetting(typeId: number, priorityTypeId: number, isToasterEnabled: boolean, updateToaster?: boolean) {

        let isToasterOn = isToasterEnabled;

        if (updateToaster) {
            isToasterOn = !isToasterEnabled;
        }
     
        var settingOptions = [
            `notificationTypeId=${typeId}`,
            `priorityTypeId=${priorityTypeId}`,
            `isToasterEnabled=${isToasterOn}`
        ].join('&');

        fetch(`/Notifications/UpdateSetting?${settingOptions}`)
            .then(res => res.json())
            .then(res => {
                if (res.isError) {
                    //error handle
                }
                else {
                    fetchSettings();
                }
            });
    }

    function displayAlertModal(type: string, title: string, message: string, secondaryMessage?: string) {
        props.displayAlertModal(type, title, message, secondaryMessage);
    }
    
    return (
        <div className={`dropdown is-right ${isSettingActive}`}>
            <div className="dropdown-trigger">
                <button className="button is-info" onClick={toggleSettingComponent}>
                    <span className="icon">
                        <FontAwesomeIcon icon={["fas", "gear"]} />
                    </span>
                    <span>Settings</span>
                </button>
            </div>
            <div className="dropdown-menu" id="dropdown-menu" role="menu">
                <div className="dropdown-content settings-container">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title has-text-centered" style={settingStyle.settingNameStyle}>
                                <span className="is-size-5 has-text-weight-bold has-text-link">Settings</span>
                            </p>
                            <button className="card-header-icon" aria-label="more options">
                                <span className="icon is-small">
                                    <FontAwesomeIcon onClick={toggleSettingComponent} icon={["fas", "remove"]} />
                                </span>
                            </button>
                        </header>
                        <div className="card-content">
                            <div className="columns">
                                <div className="column is-1"></div>
                                <div className="column">
                                    <table className="table is-scrollable">
                                        <thead>
                                            <tr>
                                                <td className="has-text-weight-bold" width="40%">Notification Types</td>
                                                <td colSpan={2} className="has-text-weight-bold has-text-centered" width="60%">Preferences</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {notificationsSettings.map((item, index) => {
                                                item.key = item.notificationTypeId;
                                                return displaySettingHtml(item, index)
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="column is-1"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NotificationSettingComponent;